import { Skeleton } from '@/components/ui/skeleton';

export function HeroSkeleton(): React.ReactElement {
  return (
    <>
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="bg-card shadow-medium rounded-xl border p-3">
          <div className="mb-1 flex justify-center">
            <Skeleton className="h-10 w-10 rounded-full" />
          </div>
          <div className="mb-1 flex justify-center">
            <Skeleton className="h-6 w-16 rounded" />
          </div>
          <div className="flex justify-center">
            <Skeleton className="h-4 w-24 rounded" />
          </div>
        </div>
      ))}
    </>
  );
}
